"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: property/listing_type.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingType = exports.protobufPackage = void 0;
exports.listingTypeFromJSON = listingTypeFromJSON;
exports.listingTypeToJSON = listingTypeToJSON;
/* eslint-disable */
exports.protobufPackage = "property";
/**
 * ListingType represents whether a property is listed for
 * rent or for sale.
 *
 * This enum is used to distinguish between rental and
 * purchase listings in the MLS system.
 */
var ListingType;
(function (ListingType) {
    /** LISTING_TYPE_UNSPECIFIED - The listing type is not specified. */
    ListingType[ListingType["LISTING_TYPE_UNSPECIFIED"] = 0] = "LISTING_TYPE_UNSPECIFIED";
    /** LISTING_TYPE_RENT - The property is listed for rent. */
    ListingType[ListingType["LISTING_TYPE_RENT"] = 1] = "LISTING_TYPE_RENT";
    /** LISTING_TYPE_BUY - The property is listed for sale. */
    ListingType[ListingType["LISTING_TYPE_BUY"] = 2] = "LISTING_TYPE_BUY";
    ListingType[ListingType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ListingType || (exports.ListingType = ListingType = {}));
function listingTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "LISTING_TYPE_UNSPECIFIED":
            return ListingType.LISTING_TYPE_UNSPECIFIED;
        case 1:
        case "LISTING_TYPE_RENT":
            return ListingType.LISTING_TYPE_RENT;
        case 2:
        case "LISTING_TYPE_BUY":
            return ListingType.LISTING_TYPE_BUY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ListingType.UNRECOGNIZED;
    }
}
function listingTypeToJSON(object) {
    switch (object) {
        case ListingType.LISTING_TYPE_UNSPECIFIED:
            return "LISTING_TYPE_UNSPECIFIED";
        case ListingType.LISTING_TYPE_RENT:
            return "LISTING_TYPE_RENT";
        case ListingType.LISTING_TYPE_BUY:
            return "LISTING_TYPE_BUY";
        case ListingType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
//# sourceMappingURL=listing_type.js.map